import React, { memo } from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';

const cx = cls(styles);
/**
 * questions-box
 * @returns
 */

const quesSetting = [
	{
		title: 'What is the dress code at AirClass?',
		desc: ['Come as you feel comfortable, but please not in swimming trunks or pajamas ;-)'],
	},
	{
		title: 'How long does the application process take?',
		desc: ['It usually takes around three working days between our first call to you and the offer being made.'],
	},
	{
		title: 'Our 3 tips for your interview:',
		desc: [
			'1. Just be yourself',
			'2. Be brave and come out of your shell ',
			'3. Convince us as to why your talent is still missing at AirClass',
		],
	},
];

export default memo(function QuestionsBox() {
	return (
		<div className={cx('questions-box')}>
			<div className={cx('questions-title')}>Frequently asked questions</div>
			<div className={cx('questions-container')}>
				<div className={cx('questions-container-list')}>
					{quesSetting.map((item, index) => (
						<div key={index} className={cx('listbar')}>
							<div className={cx('title')}>{item.title}</div>
							<div className={cx('desc')}>
								{item.desc.map((msg, idx) => (
									<p key={idx}>{msg}</p>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
});
